export default "__VITE_ASSET__Bez1$LJv__"